import { render, staticRenderFns } from "./price-match-promise.vue?vue&type=template&id=68b961da&scoped=true"
import script from "./price-match-promise.vue?vue&type=script&lang=js"
export * from "./price-match-promise.vue?vue&type=script&lang=js"
import style0 from "./price-match-promise.vue?vue&type=style&index=0&id=68b961da&prod&lang=scss&scoped=true"
import style1 from "./price-match-promise.vue?vue&type=style&index=1&id=68b961da&prod&lang=scss&scoped=true"
import style2 from "./price-match-promise.vue?vue&type=style&index=2&id=68b961da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b961da",
  null
  
)

export default component.exports